import React from 'react';
import { Link } from 'react-router-dom';
import successGif from "assets/images/icons/success-green.gif";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";

const ResetPasswordSuccess = () => {
    return (
        <>

            <DynamicHeadTag
                headerText="Reset Password"
            />

            <div className="p-8">
                <div>

                    <div className="mt-8 text-center max-w-sm">
                        <div className="h-48 sm:h-56">
                            <img src={successGif} alt="Success" className="h-full object-contain mx-auto" />
                        </div>
                        <div className="mt-4 font-semibold text-2xl sm:text-3xl">
                            Password Changed
                        </div>
                        <div className="mt-4 text-gray-500">
                            Congratulations! Your password has been reset successfully
                        </div>

                        <Link to="/login" className="btn btn-lg btn-block btn-ep-primary mt-8">Log In</Link>
                    </div>

                </div>
            </div>
            
        </>
    )
}
 
export default ResetPasswordSuccess;